<template>
    <div class="jawg-map">
        <div ref="mapContainer" style="width: 100%; height: 100%"></div>
    </div>
</template>

<script>
import { OpenStreetMapProvider } from 'leaflet-geosearch';
import Env from 'Services/Env';
import MapService from 'Services/MapService';

export default {
    props: {
        addresses: {
            type: Array,
            required: true,
        },
        selectedAddress: {
            type: Object,
            required: false,
        },
        origin: {
            type: String,
            required: false,
        },
        destination: {
            type: String,
            required: false,
        },
    },

    data() {
        return {
            addressMap: {},
            routingControl: {},
            originObject: {},
            destinationObject: {},
            routingLanguage: window.App.lang,
            jawgAccessToken: Env.get('jawg').token,
        };
    },

    mounted() {
        const self = this;
        setTimeout(() => {
            const mapContainer = self.$refs.mapContainer;
            // Init map
            if (!self.addressMap.map && mapContainer) {
                self.addressMap.map = L.map(mapContainer);
                self.addressMap.map.attributionControl.addAttribution(
                    '<a href="https://www.jawg.io" target="_blank">&copy; Jawg</a> - <a href="https://www.openstreetmap.org" target="_blank">&copy; OpenStreetMap</a>&nbsp;contributors',
                );
                L.tileLayer(MapService.getTileLayer(self.jawgAccessToken), {}).addTo(
                    self.addressMap.map,
                );

                delete L.Icon.Default.prototype._getIconUrl;

                L.Icon.Default.mergeOptions({
                    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png').default,
                    iconUrl: require('leaflet/dist/images/marker-icon.png').default,
                    shadowUrl: require('leaflet/dist/images/marker-shadow.png').default,
                });
                // Set View on selected address
                if (
                    self.selectedAddress.geocode?.lat !== null &&
                    self.selectedAddress.geocode?.lng !== null
                )
                    self.addressMap.map.setView(
                        L.latLng(
                            self.selectedAddress.geocode?.lat,
                            self.selectedAddress.geocode?.lng,
                        ),
                        12,
                    );

                // Set all marker
                for (let i = 0; i < self.addresses.length; i++) {
                    if (
                        self.addresses[i].geocode?.lat !== null &&
                        self.addresses[i].geocode?.lng !== null
                    ) {
                        let content = self.addresses[i].name;
                        content += '</br>' + self.addresses[i].address_line_1;
                        self.addresses[i].address_line_2 !== ''
                            ? (content += '</br>' + self.addresses[i].address_line_2)
                            : '';
                        self.addresses[i].address_line_3 !== ''
                            ? (content += '</br>' + self.addresses[i].address_line_3)
                            : '';
                        self.addresses[i].address_line_4 !== ''
                            ? (content += '</br>' + self.addresses[i].address_line_4)
                            : '';
                        content +=
                            '</br>' + self.addresses[i].postal_code + ' ' + self.addresses[i].city;

                        L.marker([self.addresses[i].geocode?.lat, self.addresses[i].geocode?.lng])
                            .addTo(self.addressMap.map)
                            .bindPopup(content);
                    }
                }

                self.addressMap.layerGroup = L.layerGroup().addTo(self.addressMap.map);
            }
        }, 1);
    },

    methods: {
        setZoom(address) {
            this.addressMap.map.setView(L.latLng(address.geocode?.lat, address.geocode?.lng), 16);
        },

        startRouting() {
            const self = this;
            const provider = new OpenStreetMapProvider();

            if (this.selectedAddress.hasOwnProperty('name')) {
                this.destinationObject.x = this.selectedAddress.geocode?.lng;
                this.destinationObject.y = this.selectedAddress.geocode?.lat;
            } else {
                provider.search({ query: this.destination }).then((result) => {
                    if (Array.isArray(result) && result[0]) this.destinationObject = result[0];
                });
            }

            this.addressMap.map.setView(
                L.latLng(this.destinationObject.y, this.destinationObject.x),
                15,
            );

            provider.search({ query: this.origin }).then((result) => {
                if (Array.isArray(result) && result[0]) this.originObject = result[0];
                else
                    Push.error(
                        this.$l10n.__("Cette adresse n'est pas géolocalisable par nos services"),
                    );

                if (Object.keys(self.routingControl).length > 0)
                    self.addressMap.map.removeControl(self.routingControl);

                self.routingControl = L.Routing.control({
                    router: L.Routing.osrmv1({
                        serviceUrl: 'https://api.jawg.io/routing/route/v1',
                        profile: 'car',
                        requestParameters: {
                            'access-token': this.jawgAccessToken,
                        },
                        useHints: false,
                        language: this.routingLanguage,
                    }),
                    collapsible: true,
                    waypoints: [
                        L.latLng(self.originObject.y, self.originObject.x),
                        L.latLng(self.destinationObject.y, self.destinationObject.x),
                    ],
                }).addTo(self.addressMap.map);
            });
        },
    },
};
</script>

<style lang="scss">
.jawg-map {
    width: 100%;
}
</style>
